export const descriptionSteps = [
  {
    id: 'integration.step1',
    defaultMessage:
      'Create or log in to your NIBE Flow account using the same email address you use for myUplink. This is required to establish the connection.',
  },
  { id: 'integration.step2', defaultMessage: 'Activate the integration in myUplink.' },
  {
    id: 'integration.step3',
    defaultMessage: 'Once activated, click “Fetch Devices” to view your available devices.',
  },
  { id: 'integration.step4', defaultMessage: 'Select the devices you want to migrate to myUplink and confirm.' },
];

export enum IntegrationStatus {
  INACTIVE = 'Inactive',
  ACTIVE = 'Active',
}
